import React, { Fragment, PureComponent } from "react";
import { AJAX_REQUEST, is_Mac, sentryErrorLog } from "../../Constants/AppConstants";
import Parser from "html-react-parser";
import * as RBT from "react-bootstrap";
import * as faIcon from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Tooltip from "react-bootstrap/Tooltip";
import { Scrollbars } from "react-custom-scrollbars";
import { toast } from "react-toastify";
import Hotkeys from "react-hot-keys";

export class ShortcodeArea extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      activeShortcode: "default",
      shortCodeLoading: true,
      shortCodeList: [],
      mostUsedShortcodeLoading: true,
      mostUsedShortCodeList: [],
      errorMostUsedShortCodeMessage: "",
      errorShortCodeMessage: "",
      code_search: "",
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setState({
        shortCodeLoading: false,
        shortCodeList: this.props.shortCodeList,
        errorShortCodeMessage: this.props.errorShortCodeMessage,
        mostUsedShortcodeLoading: this.props.mostUsedShortcodeLoading,
        mostUsedShortCodeList: this.props.mostUsedShortCodeList,
        errorMostUsedShortCodeMessage: this.props.errorMostUsedShortCodeMessage,
      });
    }
  }

  handleShortcode = (activeCode = 'default') => {
    this.setState({
      activeShortcode: activeCode
    });
  }


  codeSearch = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  insertAtCaret = (areaId, text) => {
    var txtarea = document.getElementById(areaId);
    if (!txtarea) {
      return;
    }

    var scrollPos = txtarea.scrollTop;
    var strPos = 0;
    var br =
      txtarea.selectionStart || txtarea.selectionStart === "0"
        ? "ff"
        : document.selection
          ? "ie"
          : false;
    if (br === "ie") {
      txtarea.focus();
      var range = document.selection.createRange();
      range.moveStart("character", -txtarea.value.length);
      strPos = range.text.length;
    } else if (br === "ff") {
      strPos = txtarea.selectionStart;
    }

    var front = txtarea.value.substring(0, strPos);
    var back = txtarea.value.substring(strPos, txtarea.value.length);
    txtarea.value = front + text + back;
    strPos = strPos + text.length;
    if (br === "ie") {
      txtarea.focus();
      var ieRange = document.selection.createRange();
      ieRange.moveStart("character", -txtarea.value.length);
      ieRange.moveStart("character", strPos);
      ieRange.moveEnd("character", 0);
      ieRange.select();
    } else if (br === "ff") {
      txtarea.selectionStart = strPos;
      txtarea.selectionEnd = strPos;
      txtarea.focus();
    }

    txtarea.scrollTop = scrollPos;
  };

  addShortcode = (e, addShortcode) => {
    e.preventDefault();
    if (addShortcode.field_type) {
      if (addShortcode.field_type === "text") {
        let field_datas = {
          user_id: this.props.current_gym_owner,
          contact_id: this.props.current_contact,
          field_name: addShortcode.field_name,
          field_id: addShortcode.id,
        };
        AJAX_REQUEST("POST", "operator/getCustomFieldTextWithLog", field_datas).then((results) => {

          // Sentry Log create
          sentryErrorLog(results);

          if (parseInt(results.response.code) === 1000) {
            let field_data = results.response.data;
            if (field_data.text) {
              this.insertAtCaret("message_chat_type_area", field_data.text);
            } else {
              toast.error("No Text Set Yet!", { autoClose: 3000 });
            }
          } else {
            toast.error(results.renspose.message, { autoClose: 3000 });
          }
        });
      } else {
        this.insertAtCaret(
          "message_chat_type_area",
          "[" + addShortcode.field_name + "]"
        );
      }
    }
  };

  onKeyDown(keyName, e, handle) {
    e.preventDefault();
    console.log("test:keyName", keyName);
    console.log("test:onKeyUpe", e);
    console.log("test:handle", handle);
    console.log("test:handle", handle.shortcut);
    document.getElementById(handle.shortcut).click();
  }

  render() {

    const ismac = (is_Mac() === 'mac') ? true : false;
    return (
      <div className="live-chat-short-code">
        {(!this.state.mostUsedShortCodeList.length <= 0 && !this.state.shortCodeList.length <= 0) ? (
          <div className="live-chat-short-code-header">
            <div className="title">
              Shortcodes
              <span className={this.state.activeShortcode === 'default' ? 'active' : 'tab-style'}
                onClick={() => this.handleShortcode('default')}
              >
                Most Used
              </span>
              <span
                className={this.state.activeShortcode !== 'default' ? 'active' : 'tab-style'}
                onClick={() => this.handleShortcode('all_shortcode')}
              >All </span>
            </div>
            <RBT.Form className="live-chat-short-code-search">
              <RBT.Form.Control
                type="text"
                placeholder="Search"
                onChange={(e) => this.codeSearch(e)}
                name="code_search"
                value={this.state.code_search}
              />
            </RBT.Form>
          </div>
        )
          :
          (
            <div className="live-chat-short-code-header">
              <div className="title">
                <span
                  className={this.state.activeShortcode !== 'default' ? 'active' : 'tab-style'}
                > </span>
                <span className={this.state.activeShortcode === 'default' ? 'active' : 'tab-style'}
                >
                </span>
              </div>
            </div>
          )
        }
        {this.state.activeShortcode === "default" ? (
          <div className="live-chat-short-code-tag">
            {this.state.mostUsedShortcodeLoading ? (
              <div className="loading">
                <FontAwesomeIcon icon={faIcon.faSyncAlt} />
              </div>
            ) : (
              <Fragment>
                {this.state.mostUsedShortCodeList.length <= 0 ? (
                  <div className="server-error-message">
                    {Parser(this.state.errorMostUsedShortCodeMessage)}
                  </div>
                ) : (
                  <Scrollbars
                    renderTrackVertical={(props) => (
                      <div {...props} className="track-vertical" />
                    )}
                    renderThumbVertical={(props) => (
                      <div {...props} className="thumb-vertical" />
                    )}
                    className="customer-sms-list-scrollbars"
                    style={{ height: 200 }}
                  >

                    <span className="shortcode-section">
                      <span className="shortcode-section-data shortcode-flex-wrap">
                        {
                          this.state.mostUsedShortCodeList.map((shortCode, key) => {
                            if (
                              this.state.code_search === "" ||
                              shortCode.field_name
                                .toUpperCase()
                                .includes(
                                  this.state.code_search.toUpperCase()
                                )
                            )
                              return (
                                <Fragment key={"mshkpar" + key}>
                                  {
                                    ismac && (shortCode.mac_key !== '') ?
                                      <Hotkeys
                                        key={"mshk" + key}
                                        keyName={`${shortCode.mac_key}`}
                                        onKeyDown={this.onKeyDown.bind(this)}
                                        filter={(event) => {
                                          return true;
                                        }}
                                      ></Hotkeys>
                                      : ''
                                  }

                                  {
                                    !ismac && (shortCode.window_key !== '') ?
                                      <Hotkeys
                                        key={"mshk" + key}
                                        keyName={`${shortCode.window_key}`}
                                        onKeyDown={this.onKeyDown.bind(this)}
                                        filter={(event) => {
                                          return true;
                                        }}
                                      ></Hotkeys>
                                      : ''
                                  }

                                  {
                                    ismac ?
                                      <RBT.OverlayTrigger
                                        key={shortCode.id}
                                        placement={"auto-start"}
                                        overlay={
                                          <Tooltip>
                                            {shortCode.field_value} (Hotkey: {shortCode.mac_key !== '' ? shortCode.mac_key : 'not assigned'})
                                          </Tooltip>
                                        }
                                      >

                                        <button
                                          id={ismac ? shortCode.mac_key : shortCode.window_key}
                                          className={`nav-link ${shortCode.window_key} ${shortCode.mac_key}`}
                                          onClick={(e) =>
                                            this.addShortcode(e, shortCode)
                                          }
                                        >
                                          [{shortCode.field_name}]
                                        </button>
                                      </RBT.OverlayTrigger>
                                      :
                                      <RBT.OverlayTrigger
                                        key={shortCode.id}
                                        placement={"auto-start"}
                                        overlay={
                                          <Tooltip>
                                            {shortCode.field_value} (Hotkey: {shortCode.window_key !== '' ? shortCode.window_key : 'not assigned'})
                                          </Tooltip>
                                        }
                                      >

                                        <button
                                          id={ismac ? shortCode.mac_key : shortCode.window_key}
                                          className={`nav-link ${shortCode.window_key} ${shortCode.mac_key}`}
                                          onClick={(e) =>
                                            this.addShortcode(e, shortCode)
                                          }
                                        >
                                          [{shortCode.field_name}]
                                        </button>
                                      </RBT.OverlayTrigger>
                                  }

                                </Fragment>

                              );
                            return true;
                          })
                        }
                      </span>
                    </span>

                  </Scrollbars>
                )}
              </Fragment>
            )}
          </div>
        ) : (
          <div className="live-chat-short-code-tag">
            {this.state.shortCodeLoading ? (
              <div className="loading">
                <FontAwesomeIcon icon={faIcon.faSyncAlt} />
              </div>
            ) : (
              <Fragment>
                {this.state.shortCodeList.length <= 0 ? (
                  <div className="server-error-message">
                    {Parser(this.state.errorShortCodeMessage)}
                  </div>
                ) : (
                  <Scrollbars
                    renderTrackVertical={(props) => (
                      <div {...props} className="track-vertical" />
                    )}
                    renderThumbVertical={(props) => (
                      <div {...props} className="thumb-vertical" />
                    )}
                    className="customer-sms-list-scrollbars"
                    style={{ height: 200 }}
                  >
                    {this.state.shortCodeList.map((shortCode_single, key) => {
                      return (
                        <span className="shortcode-section">
                          <span className="shortcode-section-title">
                            {shortCode_single.campaign_name}
                          </span>
                          {shortCode_single.fields.length > 0 ? (
                            <span className="shortcode-section-data shortcode-flex-wrap">
                              {shortCode_single.fields.map((shortCode, key) => {
                                if (
                                  this.state.code_search === "" ||
                                  shortCode.field_name
                                    .toUpperCase()
                                    .includes(
                                      this.state.code_search.toUpperCase()
                                    )
                                )
                                  return (
                                    <Fragment
                                      key={"shortcode" + shortCode.id}
                                    >
                                      {
                                        (shortCode.window_key !== '') && (shortCode.mac_key !== '') ?
                                          <Hotkeys
                                            key={"allhk" + key}
                                            keyName={`${shortCode.window_key},${shortCode.mac_key}`}
                                            onKeyDown={this.onKeyDown.bind(this)}
                                            filter={(event) => {
                                              return true;
                                            }}
                                          ></Hotkeys>
                                          : ''
                                      }

                                      <RBT.OverlayTrigger
                                        key={shortCode.id}
                                        placement={"auto-start"}
                                        overlay={
                                          <Tooltip>
                                            {shortCode.field_value} (Hotkey: {(shortCode.window_key !== '') && (shortCode.mac_key !== '') ? shortCode.window_key + ' or ' + shortCode.mac_key : 'not assigned'})
                                          </Tooltip>
                                        }
                                      >
                                        <button
                                          id={ismac ? shortCode.mac_key : shortCode.window_key}
                                          className={`nav-link ${shortCode.window_key} ${shortCode.mac_key}`}
                                          onClick={(e) =>
                                            this.addShortcode(e, shortCode)
                                          }
                                        >
                                          [{shortCode.field_name}]
                                        </button>
                                      </RBT.OverlayTrigger>
                                    </Fragment>

                                  );
                                return true;
                              })}
                            </span>
                          ) : (
                            ""
                          )}
                        </span>
                      );
                    })}
                  </Scrollbars>
                )}
              </Fragment>
            )}
          </div>
        )}
      </div>
    );
  }
}

export default ShortcodeArea;
